"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PageHeader_1 = require("./PageHeader");
var componentStyle = {
    base: {
        maxWidth: 1200,
        padding: '10px 10px 50px',
        margin: '0 auto',
    },
};
exports.Page = function (_a) {
    var children = _a.children, headerText = _a.headerText;
    return (React.createElement("div", { style: componentStyle.base },
        React.createElement(PageHeader_1.PageHeader, null, headerText),
        React.createElement("div", null, children)));
};
exports.Page.displayName = 'Page';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Page/Page.tsx
// module id = 619
// module chunks = 0